module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-0019438bc1fded3785a4e4d074d891fc.png";